<template>
	<v-container class="d-flex flex-column align-start" fluid pa-0 fill-height>
		<FullHeader :headerType="2"/>
		<ProjectListIndex :listingType="$store.projectsStore.state.listingType" />
	</v-container>
</template>

<script>
import FullHeader from '../../Globals/Headers/FullHeader'
import ProjectListIndex from './ProjectListIndex'

export default {
	name: 'ProjectsIndex',
	components: {FullHeader,ProjectListIndex},
	data: () => ({
		//
	}),
	mounted(){
	}
};
</script>
